export default "__VITE_ASSET__DzI20xW9__"